var map = {
	"./additionalInfoIcon.svg": 597,
	"./arrowLeftIcon.svg": 598,
	"./arrowMediumTop.svg": 599,
	"./arrowRightIcon.svg": 600,
	"./arrowRightIconSharp.svg": 601,
	"./arrowRightSmallIcon.svg": 602,
	"./arrowScalableIcon.svg": 603,
	"./arrowSelect2.svg": 604,
	"./arrowSelectIcon.svg": 605,
	"./benefit1.svg": 606,
	"./benefit2.svg": 607,
	"./benefit3.svg": 608,
	"./cardsIcon.svg": 609,
	"./copyIcon copy.svg": 610,
	"./copyIcon.svg": 611,
	"./crossIcon.svg": 612,
	"./crossIcon2.svg": 613,
	"./crossIcon3.svg": 614,
	"./crossIconSmall.svg": 615,
	"./crossSmallIcon.svg": 616,
	"./defaultCategoryIcon.svg": 617,
	"./depNumberIcon.svg": 618,
	"./elfCentralIcon.svg": 619,
	"./equalitySign.svg": 620,
	"./errorIcon.svg": 356,
	"./eyeClosedIcon.svg": 621,
	"./eyeOpenIcon.svg": 622,
	"./favoritesIcon.svg": 623,
	"./favoritesLabelIcon.svg": 624,
	"./filterDivider.svg": 625,
	"./filterIcon.svg": 626,
	"./frequencyIcon.svg": 627,
	"./fsAmountIcon.svg": 628,
	"./fullScreenIcon.svg": 629,
	"./gameIcon.svg": 630,
	"./hamburgerIcon.svg": 631,
	"./infoIcon.svg": 632,
	"./infoSymbol.svg": 633,
	"./levelBackground.svg": 634,
	"./levelBackgroundNew.svg": 635,
	"./linkIcon.svg": 636,
	"./lockIcon.svg": 637,
	"./lockSharpIcon.svg": 638,
	"./maxBonusAmountIcon.svg": 639,
	"./maxWinFsIcon.svg": 640,
	"./menuIcon.svg": 641,
	"./minDepIcon.svg": 642,
	"./noTournamentIcon.svg": 643,
	"./playIcon.svg": 644,
	"./polygon.svg": 645,
	"./preloaderDotsAnimation.svg": 646,
	"./preloaderSpinnerAnimation.svg": 647,
	"./presentIcon.svg": 648,
	"./promoIcon.svg": 649,
	"./recentIcon.svg": 650,
	"./search2Icon.svg": 651,
	"./search3Icon.svg": 652,
	"./sharpTickIcon copy.svg": 653,
	"./sharpTickIcon.svg": 654,
	"./smallInfoSymbol.svg": 655,
	"./smoothArrowIcon.svg": 656,
	"./successIcon.svg": 657,
	"./supportIcon.svg": 658,
	"./tag1Icon.svg": 659,
	"./tag2Icon.svg": 660,
	"./tag3Icon.svg": 661,
	"./tag4Icon.svg": 662,
	"./tickIcon.svg": 663,
	"./unverified.svg": 664,
	"./verified.svg": 665,
	"./wagerIcon.svg": 666,
	"./wagerTimeIcon.svg": 667,
	"./warningIcon.svg": 668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 596;